import React from 'react';
import IDHelpers from '../../../../../../core/helpers/IDHelper';
import { EventCardsProps } from './events.interface';
import { CardButtonEvent } from '../../card/CardButtonEvent';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const EventCardsWaitingList = ({ events, selectEvent }: EventCardsProps) => (
  <div className="gridCardEvent" data-testid="cmp-event-card-waitinglist-view2">
    {events.map((event: any) => (
      <CardButtonEvent
        key={IDHelpers.generateID()}
        event={event}
        selectEvent={() => {
          GoogleAnalytics.writeLog(
            'portal-services-cardEventRegisteredWaitingList',
            'services'
          );
          selectEvent(event.idEvent, 'ListaEspera');
        }}
      />
    ))}
  </div>
);

export default EventCardsWaitingList;
